import { shiftEntityName } from '../entities/shiftTypes';
export function getShiftStorage(context) {
    return context.storage(shiftEntityName);
}
